const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

function randomBytes(n: number): Uint8Array {
  const out = new Uint8Array(n);
  // Structurally typed rather than as DOM's `Crypto`: this package is shared
  // with the server, which compiles without the DOM library.
  const g = globalThis as { crypto?: { getRandomValues?(array: Uint8Array): Uint8Array } };
  if (g.crypto?.getRandomValues) {
    g.crypto.getRandomValues(out);
    return out;
  }
  for (let i = 0; i < n; i++) out[i] = Math.floor(Math.random() * 256);
  return out;
}

/**
 * Collision-resistant id, short enough to stay readable in a CRDT key.
 * 16 chars over a 62-char alphabet is ~95 bits, far beyond what a board needs.
 */
export function nanoid(size = 16): string {
  const bytes = randomBytes(size);
  let out = '';
  for (let i = 0; i < size; i++) out += ALPHABET[bytes[i]! % ALPHABET.length];
  return out;
}

export const createNodeId = (): string => `n_${nanoid(14)}`;
export const createBoardId = (): string => `b_${nanoid(12)}`;
export const createThreadId = (): string => `t_${nanoid(12)}`;
export const createUserId = (): string => `u_${nanoid(12)}`;
